import React from 'react';

import { TeamsIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <TeamsIcon size="xsmall" shouldUseNewLogoDesign label="" />;

export const useTeams = (fallbackUrl: FallbackUrl, options: GlobalShortcutConfiguration = {}) =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.ATLAS_TEAMS,
		analyticsName: Products.ATLAS_TEAMS,
		...options,
	});
